import { useState } from 'react';
import { X } from 'lucide-react';

const PublishTenderAlert = () => {
  const [isVisible, setIsVisible] = useState(true);
  const userType = localStorage.getItem('user_type');
  if (!isVisible) return null;

  return (
    <div className="relative mb-2">
      <div className="bg-slate-200 text-xs p-4  text-blue-800 relative ">
        {/* Close Button - Positioned Top Right */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-1 right-1 text-blue-800 hover:text-blue-600"
        >
          <X size={16} />
        </button>
        <ul className="text-sm leading-relaxed space-y-2">
          <li className="flex items-start gap-2">
            <span className="text-blue-600">●</span>*Check "See Details"* – Find
            the sample PDF for tender details. Your organization must sign and
            seal it as per the sample.
          </li>
          <li className="flex items-start gap-2">
            <span className="text-blue-600">●</span>
            *Submit Tender Request* – Upload the required file and contact
            details.
          </li>
          {userType === null && (
            <li className="flex items-start gap-2">
              <span className="text-blue-600">●</span>
              *Create & Login* – If the contact person hasn’t registered, a new
              account will be created, and login credentials will be sent.
            </li>
          )}
          <li className="flex items-start gap-2">
            <span className="text-blue-600">●</span>
            *Verification & Payment* – After verification by TenderWise, check
            the status in "View and Update My Tender" from your dashboard. Use
            "Pay Now" to complete payment.
          </li>
          <li className="flex items-start gap-2">
            <span className="text-blue-600">●</span>
            *Tender Publication* – After verification and payment, your tender
            will be published. View all your published tenders under "View All
            Published Tender Request" from your dashboard.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PublishTenderAlert;
